import { FormsSignatureBox } from './FormsSignatureBox';
import { Button } from './buttons/Button';
import { FileTypes, FormsSignatureAreaProps } from '@usacsmideo/types';
import { useUpdateChartSection } from '../hooks/useUpdateChartSection';
import * as Sentry from '@sentry/browser';

export const FormsSignatureArea = (props: FormsSignatureAreaProps) => {
  const { mutate } = useUpdateChartSection();
  const handleRemoveSignature = () => {
    // UPDATE THE HIPAA_AUTH DOC
    mutate(
      {
        patientId: props.patientId,
        docData: {
          HIPAA_AUTH: {
            signature1DataURI: '',
            exceptions: props.data.HIPAA_AUTH.exceptions || '',
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );

    // UPDATE THE CONSENT_FOR_CARE DOC
    mutate(
      {
        patientId: props.patientId,
        docData: {
          CONSENT_FOR_CARE: {
            signature1DataURI: '',
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );
  };

  return (
    <div id={props.elementId + 'area'}>
      {props.data.HIPAA_AUTH && props.data.HIPAA_AUTH.signature1DataURI?.length > 0 ? (
        <div className="" id={props.elementId + 'container'}>
          <p className="mt-4 text-lg font-bold">Signature on file:</p>
          <img
            src={props.data.HIPAA_AUTH?.signature1DataURI}
            alt="Patient Final Signature"
            className="w-1/2"
            id={props.elementId + 'image'}
          />
          <Button
            type="button"
            id={props.elementId + 'resign'}
            textContent="Re-sign"
            onClick={() => {
              props.setIsSigning({ ...props.isSigning, [props.sigName]: true });
              handleRemoveSignature();
            }}
          />
        </div>
      ) : props.isSigning[props.sigName] ? (
        <FormsSignatureBox
          elementId={props.elementId}
          type={FileTypes.patientSig}
          patientId={props.patientId}
          hideSigBox={() => props.setIsSigning({ ...props.isSigning, [props.sigName]: false })}
          sigName={props.sigName}
        />
      ) : (
        <Button
          type="button"
          id="patient-final-sig-sign-now"
          textContent="Sign Now"
          onClick={() => props.setIsSigning({ ...props.isSigning, [props.sigName]: true })}
        />
      )}
    </div>
  );
};
